import { Component } from 'react';
import { Route, Switch } from 'react-router';
import { Layout } from '../../components/Layout';
import { GlobalSettings } from './Global/GlobalSettings';
import { DeviceSettings } from './Device/DeviceSettings';
import { UserSettings } from './User/UserSettings';
import { ContactGroupSettings } from './ContactGroup/ContactGroupSettings';
import { LicenseOverview } from './Licenses/LicenseOverview';
import { PortalAccessSettings } from './PortalAcces/PortalAccessSettings';
import { ApiDocumentation } from './ApiDocumentation/ApiDocumentation';
import { NotFound } from '../NotFound';
import { AutoLogoff } from '../../components/AutoLogoff';
import { urls } from '../../logic/urls';

export class Portal extends Component {
    static displayName = Portal.name;
      
    render() {
        return (
            <AutoLogoff>
                <Layout {...this.props} >
                    <Switch>
                        <Route exact path={urls.license} component={LicenseOverview} />
                        <Route exact path={urls.tenant} component={GlobalSettings} />                    
                        <Route exact path={urls.portalAccess} component={PortalAccessSettings} />                  
                        <Route exact path={urls.device} component={DeviceSettings} />
                        <Route exact path={urls.user} component={UserSettings} />
                        <Route exact path={urls.contactGroup} component={ContactGroupSettings} />
                        <Route exact path={urls.apiDocumentation} component={ApiDocumentation} />
                        <Route path='*' component={NotFound}/>
                    </Switch>
                </Layout>
            </AutoLogoff>
        );
    }
}
